<app-side-top-bar [navigationItems]="navigationItems">
  <main class="calendar-page">
    <!-- Left Side -->
    <section class="left-side">
      <!-- Today's Appointments Card-->
      <div class="today-appointments-card">
        <span class="header"
          >Appuntamenti {{ todayDate | date: "dd/MM/yy" }}</span
        >
        @if (todayAppointments.length == 0) {
          <div class="no-appointments">
            <img
              src="assets/imgs/undraw/undraw_a_moment_to_relax_re_v5gv.svg"
              alt="No Appointments Today"
            />
            <span>Nessun appuntamento programmato</span>
          </div>
        }
        @if (todayAppointments.length > 0) {
          <div class="container-appointments">
            @for (appointment of todayAppointments; track appointment) {
              <div class="appointment">
                <app-today-appointment-card
                  [appointment]="appointment"
                  (changePatientEvent)="changePatient($event)"
                ></app-today-appointment-card>
              </div>
            }
          </div>
        }
      </div>
      <!-- Next Patient Card -->
      <div class="next-patient-card">
        @if (nextPatientFullName !== "") {
          <div class="container-next-patient">
            <div class="name" (click)="navigateToPatientPage()">
              <span>{{ nextPatientFullName }}</span>
            </div>
            <div class="reminder-header">
              <mat-icon
                style="font-size: 30px; height: 30px; width: 30px"
                [title]="'Promemoria non completati'"
                >notification_important</mat-icon
              >
              <span style="font-size: 15px"> {{ remindersNotCompleted }}</span>
            </div>
            <!-- <div class="reminders">
                <div *ngFor="let reminder of remindersNextPatient" class="reminder">
                  {{ reminder.text }}
                </div>
              </div> -->
            <div class="navigation-links-to-ai">
              <div class="navigation-link" (click)="navigateToAiPatientPage()">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="#3a569e"
                  class="size-6"
                  height="20px"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m3.75 9v6m3-3H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
                  />
                </svg>
                <span>Sintesi Complessiva</span>
              </div>
              <div
                class="navigation-link"
                (click)="navigateToLastAppointmentSummaryPage()"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="#3a569e"
                  class="size-6"
                  height="20px"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m3.75 9v6m3-3H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
                  />
                </svg>
                <span>Ultimo Appuntamento</span>
              </div>
            </div>
          </div>
        }
        @if (nextPatientFullName === "") {
          <div class="no-next-patient">
            <img
              src="assets/imgs/undraw/undraw_development.svg"
              alt="No Next Patient"
            />
            <span>Nessun paziente in programma</span>
          </div>
        }
      </div>
    </section>
    <!-- Right Side -->
    <section class="right-side">
      @if (!loadedEvents) {
        <app-loader [size]="'big'"></app-loader>
      }
      @if (loadedEvents) {
        <app-calendar
          class="calendar"
          [events]="angularCalendarEvents"
          [calendars]="calendarsGoogle"
          (newCalendarEvent)="toggleNewEventPanel($event)"
          (calendarEventClicked)="toggleModifyPanel($event)"
          (synchAppointments)="synchAppointments()"
        ></app-calendar>
      }
    </section>

    @if (showNewCalendarEventPanel) {
      <app-panel-calendar-event
        [patients]="allPatients"
        [calendars]="calendarsGoogle"
        [newAppointmentDay]="newAppointmentDay"
        [newAppointmentMonth]="newAppointmentMonth"
        [newAppointmentYear]="newAppointmentYear"
        [newAppointmentHours]="newAppointmentHours"
        [newAppointmentMinutes]="newAppointmentMinutes"
        (cancel)="toggleNewEventPanel()"
        (confirm)="addNewEvent($event)"
      ></app-panel-calendar-event>
    }

    @if (showModifyCalendarEventPanel) {
      <app-panel-modify-calendar-event
        [appointmentDay]="modifyAppointmentDay"
        [appointmentMonth]="modifyAppointmentMonth"
        [appointmentYear]="modifyAppointmentYear"
        [appointmentId]="modifyAppointmentId"
        [appointmentStartHours]="modifyAppointmentStartHours"
        [appointmentEndHours]="modifyAppointmentEndHours"
        [appointmentStartMinutes]="modifyAppointmentStartMinutes"
        [appointmentEndMinutes]="modifyAppointmentEndMinutes"
        [appointmentTitle]="modifyAppointmentTitle"
        [isAppointmentAllDay]="isAppointmentAllDay"
        [isAppointmentModifiable]="isAppointmentModifiable"
        [title]="modifyTitleCard"
        (cancel)="toggleModifyPanel()"
        (confirm)="modifyCalendarEvent($event)"
        (delete)="deleteCalendarEvent($event)"
      ></app-panel-modify-calendar-event>
    }
  </main>
</app-side-top-bar>
